<template>
  <div class="nav">
    <MenuList v-if="menu" :responsive="responsive" :lang="lang" :list="menu.list" />
    <!-- <a href="#" class="btn btnFull">셀프 체크아웃</a> -->
    <Sns :list="sns" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuList from '@/components/Nav/MenuList.vue'
import Sns from '@/components/Nav/Sns.vue'

export default {
  name: 'Nav',
  props: [
    'lang',
    'responsive'
  ],
  components: {
    MenuList,
    Sns
  },
  computed: {
    ...mapGetters({
      menu: 'common/getMenu'
    }),
    sns () {
      return this.menu.sns.filter(x => x.active)
    }
  }
}
</script>
